/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import pentagonUrl from '../../../assets/gems/pentagon.svg?inline';
export function Pentagon({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: pentagonUrl,
        alt: "PentagonImage"
    });
}
